export type RGBA = { r: number; g: number; b: number; a: number };

export function getContrastColorFromRGBA(r: number, g: number, b: number, a = 1): string {
  let R = r, G = g, B = b;
  
  if (a >= 0.5) {
    R = r * a;
    G = g * a;
    B = b * a;
  }
  const yiq = (R * 299 + G * 587 + B * 114) / 1000;
  
  return yiq >= 128 ? "#000000" : "#FFFFFF";
}


export function parseRGBA(color: string | null | undefined): RGBA | null {
  if (!color) return null;
  if (color === "transparent") return { r: 0, g: 0, b: 0, a: 0 };
  
  let r = 0, g = 0, b = 0, a = 1;

  if (color.startsWith("rgb")) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (match) {
      r = parseInt(match[1], 10);
      g = parseInt(match[2], 10);
      b = parseInt(match[3], 10);
      a = match[4] !== undefined ? parseFloat(match[4]) : 1;
    }
  } else {
    const hex = color.replace("#", "");
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return { r, g, b, a };
}

export function getEffectiveBg(el: HTMLElement) {
  const candidates = [
    getComputedStyle(el).backgroundColor,
    getComputedStyle(el, '::before').backgroundColor,
    getComputedStyle(el, '::after').backgroundColor,
  ];
  for (const c of candidates) {
    const rgba = parseRGBA(c);
    if (rgba && rgba.a > 0) return rgba;
  }
  return parseRGBA(candidates[0]) || null;
}